function isUnsetMargeOperand(value) {
     if (value === undefined || value === null || value === "") {
          return true;
     }
     if (typeof value === "number" && Number.isNaN(value)) {
          return true;
     }
     if (String(value).trim().toLowerCase() === "nan") {
          return true;
     }
     const parsed = typeof value === "number" ? value : Number(String(value).trim().replace(",", "."));
     return !Number.isFinite(parsed);
}

export function hasConfiguredMargeOperand(formula) {
     if (!formula || typeof formula !== "object") {
          return false;
     }
     return ["X", "Y", "Z"].some((key) => !isUnsetMargeOperand(formula[key]));
}
